import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Alert, AlertDescription } from '@/components/ui/alert';

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [status, setStatus] = useState<'pending' | 'ok' | 'error'>('pending');
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setStatus('error');
      setError('no token in URL');
      return;
    }
    // Better Auth verification endpoint
    fetch(`/api/auth/verify-email?token=${encodeURIComponent(token)}`, {
      method: 'GET',
    })
      .then(async (res) => {
        if (res.ok) setStatus('ok');
        else {
          const body = (await res.json().catch(() => null)) as { error?: string } | null;
          setStatus('error');
          setError(body?.error ?? `verification failed (${res.status})`);
        }
      })
      .catch((err) => {
        setStatus('error');
        setError(err instanceof Error ? err.message : 'verification failed');
      });
  }, [token]);

  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-muted/30">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Verify your email</CardTitle>
          <CardDescription>
            {status === 'pending' && 'Verifying your email address…'}
            {status === 'ok' && 'Your email has been verified.'}
            {status === 'error' && 'Verification failed.'}
          </CardDescription>
        </CardHeader>
        <CardContent>
          {status === 'error' && error && (
            <Alert variant="destructive" className="mb-4">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          <Link to="/login" className="text-sm underline-offset-4 hover:underline">
            Continue to sign in →
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
